/**
 * Transfer Service
 * Handles product transfer API calls
 */

import { api } from '../lib/axios';

export interface Transfer {
  id: string;
  productId: string;
  fromUserId: string;
  toUserId: string;
  blockchainTxHash: string | null;
  status: string;
  createdAt: string;
  product?: {
    serialNumber: number;
    batch: {
      productName: string;
    };
  };
  fromUser?: {
    fullName: string;
  };
  toUser?: {
    fullName: string;
  };
}

export interface CreateTransferData {
  productId: string;
  toUserId: string;
}

class TransferService {
  /**
   * Create a product transfer
   */
  async createTransfer(data: CreateTransferData): Promise<Transfer> {
    const response = await api.post('/transfers', data);
    return response.data.transfer;
  }

  /**
   * Get user's sent transfers
   */
  async getSentTransfers(): Promise<Transfer[]> {
    const response = await api.get('/transfers/sent');
    return response.data.transfers;
  }

  /**
   * Get user's received transfers
   */
  async getReceivedTransfers(): Promise<Transfer[]> {
    const response = await api.get('/transfers/received');
    return response.data.transfers;
  }

  /**
   * Get all transfers for current user (sent + received)
   */
  async getAllTransfers(): Promise<{ sent: Transfer[]; received: Transfer[] }> {
    const [sent, received] = await Promise.all([
      this.getSentTransfers(),
      this.getReceivedTransfers()
    ]);
    return { sent, received };
  }

  /**
   * Confirm transfer receipt
   */
  async confirmTransfer(transferId: string): Promise<void> {
    await api.post(`/api/transfers/${transferId}/confirm`);
  }
}

export const transferService = new TransferService();
